import {cssTheme} from '@yandex-delivery/blocks';
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const listClasses = {
  countryList: css`
    margin-block: 0;
    padding: 0;
    list-style: none;
    display: grid;
    inline-size: max-content;
    color: ${cssTheme.default.day.everWhite};
  `,
  listItem: css`
    margin-block: ${spacing(0.3125)};
  `,
}
